module.exports = __webpack_public_path__ + "img/question_tip.06e22ed5.svg";